import { useEffect, useState } from "react";
import AdminShell, { ADMIN_NAV } from "../components/admin/AdminShell";
import LoginView from "../components/admin/LoginView";
import ChangePasswordView from "../components/admin/ChangePasswordView";
import DashboardView from "../components/admin/DashboardView";
import PipelineView from "../components/admin/PipelineView";
import RecruitsView from "../components/admin/RecruitsView";
import AgentsView from "../components/admin/AgentsView";
import RecruitDrawer from "../components/admin/RecruitDrawer";
import NotificationsSheet, { PushBanner, usePush } from "../components/admin/NotificationsSheet";
import useCrm from "../components/admin/useCrm";
import { useLeadDeepLink } from "../components/admin/useLeadDeepLink";

export default function AdminPage() {
  const crm = useCrm({ tokenKey: "breeze_admin_token", role: "admin" });
  const [view, setView] = useState("dashboard");
  const [selectedId, setSelectedId] = useState(null);
  const [pwOpen, setPwOpen] = useState(false);
  const [notifOpen, setNotifOpen] = useState(false);
  const { leads, agents, stats, user } = crm;
  const push = usePush(crm.api, !!crm.token);
  useLeadDeepLink(leads, setSelectedId);

  useEffect(() => { if (!crm.token) setNotifOpen(false); }, [crm.token]);

  if (!crm.token) return <LoginView onLogin={crm.login} variant="admin" />;

  const selected = leads.find((l) => l.id === selectedId) || null;
  const counts = { pipeline: leads.filter((l) => !["Onboarded", "Lost"].includes(l.status)).length, recruits: leads.length, agents: agents.length };
  const newCount = leads.filter((l) => l.status === "New").length;

  return (
    <AdminShell nav={ADMIN_NAV} brandLabel="Recruiting CRM" view={view} setView={setView} counts={counts} user={user} loading={crm.loading}
      onRefresh={crm.load} onLogout={crm.logout} onChangePassword={() => setPwOpen(true)} onNotifications={() => setNotifOpen(true)} pushOn={push.subscribed} newCount={newCount}>
      {view === "dashboard" && (
        <div className="space-y-4">
          <PushBanner push={push} onOpen={() => setNotifOpen(true)} />
          <DashboardView stats={stats} leads={leads} onOpen={setSelectedId} goTo={setView} />
        </div>
      )}
      {view === "pipeline" && <PipelineView leads={leads} onMove={crm.setStage} onOpen={setSelectedId} />}
      {view === "recruits" && <RecruitsView leads={leads} agents={agents} onOpen={setSelectedId} onStage={crm.setStage} />}
      {view === "agents" && <AgentsView agents={agents} leaderboard={stats?.leaderboard} onAdd={crm.addAgent} onInvite={crm.inviteAgent} onToggle={crm.toggleAgent} onRemove={crm.removeAgent} />}
      <RecruitDrawer lead={selected} agents={agents} onClose={() => setSelectedId(null)} onStage={crm.setStage} onReassign={crm.reassign}
        onAddNote={crm.addNote} onDeleteNote={crm.deleteNote} onDelete={async (id) => { if (await crm.deleteLead(id)) setSelectedId(null); }} />
      {pwOpen && <ChangePasswordView onSubmit={crm.changePassword} onClose={() => setPwOpen(false)} />}
      {notifOpen && <NotificationsSheet push={push} role="admin" onClose={() => setNotifOpen(false)} />}
    </AdminShell>
  );
}
